import React, { useCallback, useEffect, useState } from 'react'
import { useRecoilValue } from 'recoil'

import teacher_out_bgImg from '@/assets/images/teacher-out-bg.png'
import Modal from '@/components/Modal'
import { rtmReadyState } from '@/store/room'
import { ipcInvoke, ipcOn } from '@/utils/electron'

import { rtmClient } from '../..'

export default function Index() {
  const rtmReady = useRecoilValue(rtmReadyState) // rtm是否准备好
  const [minimize, setMinimize] = useState(false) // 是否最小化
  const [kickOutTeacher, setKickOutTeacher] = useState(false) // 是否踢出老师

  useEffect(() => {
    // 最小化
    ipcOn('minimize', (...agrs) => {
      setMinimize(true)
    })
    // 恢复
    ipcOn('restore', (...agrs) => {
      setMinimize(false)
    })
    // 默认状态是否最小化
    ipcInvoke('win', { method: 'isMinimized' }).then((res) => {
      const { data } = res
      setMinimize(data)
    })
    rtmClient.on('ArtKickOutTeacher', ArtKickOutTeacher)
    return () => {
      // 销毁
      rtmClient.removeListener('ArtKickOutTeacher', ArtKickOutTeacher)
    }
  }, [])

  useEffect(() => {
    if (rtmReady) {
      console.log('是否最小化:', minimize)
      rtmClient.sendMessage('ArtEnterBackgroundControl', { back: minimize })
    }
  }, [rtmReady, minimize])

  const ArtKickOutTeacher = useCallback((memberId: string, payload: any) => {
    setKickOutTeacher(true)
  }, [])

  return (
    <>
      <Modal className="w-[300px] !min-w-[300px]" show={kickOutTeacher} header={''} title="提示" close={false} confirm={null} cancel={() => setKickOutTeacher(false)} cancelText="我知道了">
        <img className="w-[300px] mt-[-72px]" src={teacher_out_bgImg} alt="" />
        <p className="py-[10px] text-[16px] mt-[20px] text-[#333] text-center">稍等片刻，请不要离开教室哦</p>
      </Modal>
    </>
  )
}
